/**
 * ELINROSE — Scarcity & Urgency Snippet
 * Installazione: Shopify Admin → Themes → Edit Code
 * → assets/ → nuovo file "elinrose-scarcity.js"
 * Poi in layout/theme.liquid prima di </body>:
 * <script src="{{ 'elinrose-scarcity.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ── CONFIG ─────────────────────────────── */
  var MUTTERTAG     = new Date('2026-05-10T00:00:00');
  var TOAST_DELAY   = 8000;   // prima notifica dopo 8s
  var TOAST_REPEAT  = 50000;  // poi ogni 50s
  /* ────────────────────────────────────────── */

  var style = document.createElement('style');
  style.textContent = `
    /* ── TOP BAR ── */
    #el-bar {
      background: #3a2208;
      color: #e8d5b0;
      text-align: center;
      padding: 9px 40px;
      font-family: Arial, sans-serif;
      font-size: 13px;
      letter-spacing: .5px;
      position: relative;
      z-index: 9000;
    }
    #el-bar a { color: #c9a96e; text-decoration: none; font-weight: bold; }
    #el-bar a:hover { text-decoration: underline; }
    #el-bar-close {
      position: absolute; right: 14px; top: 50%;
      transform: translateY(-50%);
      background: none; border: none;
      color: #c9a96e; font-size: 16px;
      cursor: pointer; padding: 4px; line-height:1;
    }
    #el-clock { font-variant-numeric: tabular-nums; }

    /* ── SOCIAL PROOF TOAST ── */
    #el-toast {
      position: fixed;
      bottom: 20px; left: 20px;
      background: #fff;
      border-left: 3px solid #c9a96e;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0,0,0,.12);
      padding: 12px 16px;
      max-width: 260px;
      z-index: 9999;
      font-family: Arial, sans-serif;
      font-size: 12px;
      color: #444;
      line-height: 1.4;
      transform: translateX(-110%);
      transition: transform .4s cubic-bezier(.34,1.56,.64,1);
      pointer-events: none;
    }
    #el-toast.show { transform: translateX(0); }
    #el-toast strong { color: #3a2208; font-size: 13px; }
    #el-toast-icon { font-size: 18px; margin-right: 6px; vertical-align: middle; }

    /* ── LOW STOCK BADGE ── */
    .el-stock-badge {
      display: inline-block;
      font-family: Arial, sans-serif;
      font-size: 12px;
      color: #c0392b;
      font-weight: bold;
      margin: 6px 0 10px;
      letter-spacing: .3px;
    }
    .el-stock-badge::before { content: '⚡ '; }

    /* ── MOBILE ── */
    @media (max-width: 600px) {
      #el-bar { font-size: 11px; padding: 8px 36px; }
      #el-toast { left: 50%; transform: translateX(-50%) translateY(120%); max-width: 88vw; bottom: 16px; }
      #el-toast.show { transform: translateX(-50%) translateY(0); }
    }
  `;
  document.head.appendChild(style);

  /* ══ 1. TOP COUNTDOWN BAR ══════════════════════════════ */
  function msLeft() { return MUTTERTAG - new Date(); }

  function buildBar() {
    if (msLeft() <= 0) return;
    if (sessionStorage.getItem('el_bar_closed')) return;

    var bar = document.createElement('div');
    bar.id = 'el-bar';
    bar.innerHTML =
      '🌸 <strong>Muttertag</strong> — noch <span id="el-clock"></span> · ' +
      '<a href="/collections/all">Jetzt Geschenk wählen →</a>' +
      '<button id="el-bar-close" aria-label="Schließen">✕</button>';

    document.body.insertBefore(bar, document.body.firstChild);

    document.getElementById('el-bar-close').onclick = function () {
      bar.remove();
      sessionStorage.setItem('el_bar_closed', '1');
    };

    updateClock();
    setInterval(updateClock, 1000);
  }

  function updateClock() {
    var el = document.getElementById('el-clock');
    if (!el) return;
    var ms = msLeft();
    if (ms <= 0) { el.closest('#el-bar') && el.closest('#el-bar').remove(); return; }
    var d = Math.floor(ms / 864e5);
    var h = Math.floor((ms % 864e5) / 36e5);
    var m = Math.floor((ms % 36e5) / 6e4);
    var s = Math.floor((ms % 6e4) / 1e3);
    el.textContent =
      (d > 0 ? d + 'T ' : '') +
      String(h).padStart(2,'0') + ':' +
      String(m).padStart(2,'0') + ':' +
      String(s).padStart(2,'0');
  }

  /* ══ 2. SOCIAL PROOF TOAST ═════════════════════════════ */
  var toastData = [
    { name: 'Sarah', city: 'München',   product: 'Foto Halskette',        time: 'vor 12 Min.' },
    { name: 'Julia', city: 'Berlin',    product: 'Namenskette',            time: 'vor 28 Min.' },
    { name: 'Anna',  city: 'Hamburg',   product: 'Herzklang Ring',         time: 'vor 45 Min.' },
    { name: 'Lena',  city: 'Frankfurt', product: 'Gravur Armband',         time: 'vor 1 Std.'  },
    { name: 'Marie', city: 'Köln',      product: 'Fingerabdruck Halskette',time: 'vor 2 Std.'  },
  ];
  var toastIdx = 0;

  function buildToast() {
    var t = document.createElement('div');
    t.id = 'el-toast';
    t.setAttribute('aria-live', 'polite');
    document.body.appendChild(t);
  }

  function showToast() {
    var t = document.getElementById('el-toast');
    if (!t) return;
    var d = toastData[toastIdx % toastData.length];
    toastIdx++;
    t.innerHTML =
      '<span id="el-toast-icon">🛍️</span>' +
      '<strong>' + d.name + '</strong> aus ' + d.city + '<br>' +
      'hat gerade <em>' + d.product + '</em> gekauft<br>' +
      '<span style="color:#9a7a50;font-size:11px">' + d.time + '</span>';
    t.classList.add('show');
    setTimeout(function () { t.classList.remove('show'); }, 4000);
  }

  /* ══ 3. LOW STOCK BADGE ════════════════════════════════ */
  // Aggiunge un badge discreto vicino al bottone "Aggiungi al carrello"
  // Solo sulle pagine prodotto (URL /products/)
  function injectStockBadge() {
    if (!window.location.pathname.includes('/products/')) return;

    // Cerca il form aggiungi al carrello
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // Evita duplicati
    if (form.querySelector('.el-stock-badge')) return;

    var messages = [
      'Nur noch wenige verfügbar',
      'Sehr beliebt — fast ausverkauft',
      'Limitierte Stückzahl'
    ];
    var msg = messages[Math.floor(Math.random() * messages.length)];

    var badge = document.createElement('p');
    badge.className = 'el-stock-badge';
    badge.textContent = msg;

    // Inserisce prima del bottone submit
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.parentNode.insertBefore(badge, btn);
    else form.prepend(badge);
  }

  /* ══ INIT ═══════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    buildBar();
    buildToast();
    injectStockBadge();
    setTimeout(function () {
      showToast();
      setInterval(showToast, TOAST_REPEAT);
    }, TOAST_DELAY);
  });

})();